import React from 'react';
import { core } from '@mentimeter/http-clients';
import type { QuizPlayersScoreData } from '@mentimeter/core-hooks';
import { PresenterRoutes } from '@mentimeter/quiz-types';
import { mergeMarkedAnswer } from '../merge-marked-answer';
import { useQuizMetaContext } from '../quiz-meta-provider';
import { useQuizConfig } from '../quiz-config.presenter';
import { useQuizResults } from '../quiz-result-provider';
import { useEmit } from './use-emit';

export const useQuizResultActions = (questionId: string) => {
  const config = useQuizConfig();
  const { emit } = useEmit(config);
  const follower = useQuizMetaContext().follower;
  const { mutate } = useQuizResults<QuizPlayersScoreData>();

  const markAnswer = React.useCallback(
    async (payload: {
      identifiers: string[];
      marked_correct: boolean;
      marked_inappropriate: boolean;
    }) => {
      if (follower) return;

      mutate((players) => mergeMarkedAnswer(payload, players ?? []), {
        revalidate: false,
      });
      const { data } = await core().questions.quizPlayers.put(
        questionId,
        payload,
      );

      // Emit to voters
      await emit(PresenterRoutes.MarkedAnswer, { scores: data });
      return data;
    },
    [emit, follower, mutate, questionId],
  );

  return { markAnswer };
};
